module.exports = __webpack_public_path__ + "static/media/segmentationTargeting-01.71549a96.png";